// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Custom
import Section from '@/components/sections/Section'

// Style
import themeColors from 'assets/theme/colors'
import { getFontBody } from '@/assets/theme/fonts'

export default function IntroSection() {
  const { t } = useTranslation('index')

  const getContent = () => (
    <Box sx={{ width: '100%', maxWidth: '54rem' }}>
      {[t('intro.p1'), t('intro.p2')].map(paragraph => (
        <Typography
          key={paragraph}
          component="p"
          fontSize={getFontBody()}
          sx={{
            lineHeight: 1.75,
            color: themeColors.gray.defaultText,
            marginBottom: '1.1rem'
          }}
        >
          {paragraph}
        </Typography>
      ))}

      <Typography
        component="p"
        fontSize={getFontBody()}
        sx={{
          marginTop: '1.5rem',
          paddingLeft: '1rem',
          borderLeft: `3px solid ${themeColors.success.main}`,
          lineHeight: 1.75,
          fontWeight: 500,
          color: themeColors.gray.dark
        }}
      >
        {t('intro.p3')}
      </Typography>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
